<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> ビフォーアフター</span>
        </div>
        <div class="card-body">
          <label class="col-form-label">初回</label>
          @if (loading) {
            <div class="carousel-loading" role="status">
              <span class="spinner-border text-primary" aria-hidden="true"></span>
              <span class="sr-only">画像を読み込んでいます。</span>
            </div>
          } @else if (firstImages.length > 0) {
            <div
              class="photo-carousel"
              data-carousel="first"
              role="region"
              aria-label="初回の画像カルーセル"
              tabindex="0"
              [style.--slides-per-view]="slidesPerView"
              (keydown)="onCarouselKeydown($event, 'first')"
              (pointerdown)="onPointerDown($event, 'first')"
              (pointerup)="onPointerUp($event, 'first')"
              (pointercancel)="onPointerCancel()"
            >
              <div class="photo-carousel-viewport">
                <div class="photo-carousel-track" [style.transform]="trackTransform('first')">
                  @for (src of firstImages; track src; let index = $index) {
                    <figure
                      class="photo-carousel-slide"
                      [attr.aria-hidden]="isSlideVisible('first', index) ? null : 'true'"
                    >
                      <img class="img-thumbnail" [src]="src" [alt]="'初回の写真 ' + (index + 1)" draggable="false">
                    </figure>
                  }
                </div>
              </div>
              @if (carouselStops('first').length > 1) {
                <button
                  type="button"
                  class="photo-carousel-control previous"
                  data-action="previous"
                  title="前の画像"
                  aria-label="前の画像"
                  [disabled]="!canMovePrevious('first')"
                  (click)="previous('first')"
                ></button>
                <button
                  type="button"
                  class="photo-carousel-control next"
                  data-action="next"
                  title="次の画像"
                  aria-label="次の画像"
                  [disabled]="!canMoveNext('first')"
                  (click)="next('first')"
                ></button>
                <div class="photo-carousel-indicators" aria-label="初回画像の表示位置">
                  @for (stop of carouselStops('first'); track stop) {
                    <button
                      type="button"
                      [class.active]="firstIndex === stop"
                      [attr.aria-current]="firstIndex === stop ? 'true' : null"
                      [attr.aria-label]="'初回画像 ' + (stop + 1) + '枚目から表示'"
                      (click)="goTo('first', stop)"
                    ></button>
                  }
                </div>
              }
            </div>
          } @else {
            <p class="photo-empty">画像はありません。</p>
          }
        </div>
        <div class="card-body">
          <label class="col-form-label">最新</label>
          @if (loading) {
            <div class="carousel-loading" role="status">
              <span class="spinner-border text-primary" aria-hidden="true"></span>
              <span class="sr-only">画像を読み込んでいます。</span>
            </div>
          } @else if (latestImages.length > 0) {
            <div
              class="photo-carousel"
              data-carousel="latest"
              role="region"
              aria-label="最新の画像カルーセル"
              tabindex="0"
              [style.--slides-per-view]="slidesPerView"
              (keydown)="onCarouselKeydown($event, 'latest')"
              (pointerdown)="onPointerDown($event, 'latest')"
              (pointerup)="onPointerUp($event, 'latest')"
              (pointercancel)="onPointerCancel()"
            >
              <div class="photo-carousel-viewport">
                <div class="photo-carousel-track" [style.transform]="trackTransform('latest')">
                  @for (src of latestImages; track src; let index = $index) {
                    <figure
                      class="photo-carousel-slide"
                      [attr.aria-hidden]="isSlideVisible('latest', index) ? null : 'true'"
                    >
                      <img class="img-thumbnail" [src]="src" [alt]="'最新の写真 ' + (index + 1)" draggable="false">
                    </figure>
                  }
                </div>
              </div>
              @if (carouselStops('latest').length > 1) {
                <button
                  type="button"
                  class="photo-carousel-control previous"
                  data-action="previous"
                  title="前の画像"
                  aria-label="前の画像"
                  [disabled]="!canMovePrevious('latest')"
                  (click)="previous('latest')"
                ></button>
                <button
                  type="button"
                  class="photo-carousel-control next"
                  data-action="next"
                  title="次の画像"
                  aria-label="次の画像"
                  [disabled]="!canMoveNext('latest')"
                  (click)="next('latest')"
                ></button>
                <div class="photo-carousel-indicators" aria-label="最新画像の表示位置">
                  @for (stop of carouselStops('latest'); track stop) {
                    <button
                      type="button"
                      [class.active]="latestIndex === stop"
                      [attr.aria-current]="latestIndex === stop ? 'true' : null"
                      [attr.aria-label]="'最新画像 ' + (stop + 1) + '枚目から表示'"
                      (click)="goTo('latest', stop)"
                    ></button>
                  }
                </div>
              }
            </div>
          } @else {
            <p class="photo-empty">画像はありません。</p>
          }
        </div>
        <div class="card-body">
          <div class="row">
            <div class="d-none d-sm-block col-md-12 text-right">
              <button routerLink="/counsel" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
            </div>
            <div class="d-block d-sm-none col-12">
              <button routerLink="/counsel" class="btn bg-close text-white col-12 form-group"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
